var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1603_31775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 2.5H2.5V27.5H27.5V2.5Z",
    fill: "#0091D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5L8.74817 8.75183L15 2.5H2.5Z",
    fill: "#0091D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5V15L8.74817 8.75183L2.5 2.5Z",
    fill: "#009AD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14.9999L8.75183 8.74805L2.5 14.9999H15Z",
    fill: "#0091D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 15V2.5L8.75195 8.74817L15.0001 15Z",
    fill: "#0082C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5V15L21.2482 8.75183L15 2.5Z",
    fill: "#0071BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 14.9999L21.2518 8.74805L15 14.9999H27.5Z",
    fill: "#004C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15L8.74817 21.2518L15 15H2.5Z",
    fill: "#0082C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15V27.5L8.74817 21.2518L2.5 15Z",
    fill: "#0071BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 27.4999L8.75183 21.248L2.5 27.4999H15Z",
    fill: "#0066B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 27.5V15L8.75195 21.2482L15.0001 27.5Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15L21.2482 21.2518L27.5 15H15Z",
    fill: "#1B3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15V27.5L21.2482 21.2518L15 15Z",
    fill: "#004C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 27.4999L21.2518 21.248L15 27.4999H27.5Z",
    fill: "#1B3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5001 27.5V15L21.252 21.2482L27.5001 27.5Z",
    fill: "#1B3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5L21.2482 8.75183L27.5 2.5H15Z",
    fill: "#0066B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5001 15V2.5L21.252 8.74817L27.5001 15Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5001 18.1261L19.4954 10.5049L7.34961 22.6799L11.7792 27.1095L19.4954 19.5138L27.5001 27.4746V18.1261Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1603_31775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(2.5 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/전북-30.1ee2c8e5b3de0476b8fedf5b09ebee15.svg";
export { ForwardRef as ReactComponent };